export default __webpack_public_path__ + "static/media/fifa1-bg.f3ff9457.jpg";